import React from "react";
import { MessageCircle } from "lucide-react";

const WA_NUMBER = "905456534494"; // +90 545 653 44 94
const WA_TEXT =
  "Merhaba MoDuLerİS, web sitenizden ulaşıyorum. Projem hakkında bilgi almak istiyorum.";

export const WhatsAppFab = () => {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT)}`;
  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[70] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <span className="relative flex items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:bg-[#1eb955] transition-colors">
        <MessageCircle size={20} strokeWidth={2.2} />
        <span className="hidden md:inline text-[12px] uppercase tracking-[0.22em] font-semibold">
          WhatsApp
        </span>
      </span>
    </a>
  );
};

export default WhatsAppFab;
